import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Auth/Login';
import Home from './components/Home/Home';
import IdleLogout from './components/common/IdleLogout';
import './App.css';

function App() {
  const ProtectedRoute = ({ children }) => {
    const isAuthed = typeof window !== 'undefined' && localStorage.getItem('auth') === 'true';
    if (isAuthed) return children;
    if (window.showPreloader) { window.showPreloader(); }
    // window.alert('Unauthorized request. Please login first.');
    return <Navigate to="/" replace />;
  };

  return (
    <BrowserRouter>
      <IdleLogout />
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;